module.exports = __webpack_public_path__ + "1076e60b8de9b7372487ef279b1548b9.png";